export function isPhoneValidation(validations?: { type: string }[]) {
  return validations?.some(({ type }) => type === 'phone');
}
